import React, { useEffect, useState } from "react";
import { Spin, Modal } from "antd";
import { getRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { toast } from "react-toastify";
import Preview from "../Preview/preview";
import "../table/viewMicrosite.scss";

export default function ViewMicrositeDetails({
  orgId,
  closeModal,
}) {
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [oneOrgData, setOneOrgData] = useState(null);
  const [microsite, setMicrosite] = useState(null);

  const getOneOrganizationData = async () => {
    if (orgId) {
      try {
        setLoading(true);
        const response = await getRequest(
          userServiceApi.getOneOrganization(orgId)
        );

        if (response.data) {
          setOneOrgData(response.data);
        }
      } catch (error) {
        toast.error(error.error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getOneOrganizationData();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  const RemoveMicrosite = () => {
    setMicrosite(null);
  };

  const handleCancel = () => {
    closeModal();
  };
  // console.log(oneOrgData);
  if (loading || loader) {
    // return (
    //   <div className="data-loader">
    //     <Spin className="spin" tip="Loading" size="large" />
    //   </div>
    // );
  }
  // else {
  return (
    <>
      <Modal
        open={true}
        onCancel={handleCancel}
        // closeIcon={<img className="closeIcon" src={closeIcon} />}
        footer={null}
        className="viewMicrositeModal"
      >
        {loading || loader ? (
          <div className="approve-container">
            <div className="data-loader">
              <Spin className="spin" tip="Loading" size="large" />
            </div>
          </div>
        ) : (
          <div className="approve-container">

            <div className="partnerInfoStyle">

              {oneOrgData?.mediaLink ? (
                <div className="partnerInfoRow">
                  <div className="partnerInfoCol">
                    <div className="img-container">
                      <img
                        src={oneOrgData?.mediaLink}
                        alt={""}
                        className="preview-image"
                      />
                    </div>
                  </div>
                  <div className="partnerInfoCol">
                    {/* <div className="btn-container">
                     {microsites.map((microsite) => {
                       return (
                         <div className="inputBody-btns">
                           <Button
                             className="view-btn"
                             type="button"
                             onClick={() => ShowSubsectionhandler(microsite.id)}
                           >
                             View Site
                           </Button>
                         </div>
                       );
                     })}
                   </div> */}
                  </div>
                </div>
              ) : null}

              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Name</div>
                <div className="partnerInfoCol">{oneOrgData?.name}</div>
              </div>
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Type</div>
                <div className="partnerInfoCol">{oneOrgData?.type?.length > 0 ? oneOrgData?.type : ""}</div>
              </div>
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Size</div>
                <div className="partnerInfoCol">
                  {oneOrgData?.size === "MICRO"
                    ? "Micro"
                    : oneOrgData?.size === "SMALL"
                      ? "Small"
                      : oneOrgData?.size === "MEDIUM"
                        ? "Medium"
                        : oneOrgData?.size === "LARGE"
                          ? "Large"
                          : ""}
                </div>
              </div>
              {oneOrgData?.sectorsOutputs?.length > 0 &&
                oneOrgData?.sectorsOutputs[0]?.sectorOutput?.name && (
                  <div className="partnerInfoRow">
                    <div className="partnerInfoCol">Categories</div>
                    <div className="partnerInfoCol">
                      {oneOrgData.sectorsOutputs[0].sectorOutput.name}
                    </div>
                  </div>
                )}

              {oneOrgData?.sectorsOutputs?.length > 0 &&
                oneOrgData?.sectorsOutputs[0]?.subSectorOutput?.name && (
                  <div className="partnerInfoRow">
                    <div className="partnerInfoCol">Sub categories</div>
                    <div className="partnerInfoCol">
                      {oneOrgData.sectorsOutputs[0].subSectorOutput.name}
                    </div>
                  </div>
                )}

              {oneOrgData?.websiteLink ? (
                <div className="partnerInfoRow">
                  <div className="partnerInfoCol">Website</div>
                  <div className="partnerInfoCol"> {oneOrgData?.websiteLink}</div>
                </div>
              ) : null}

              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Email</div>
                <div className="partnerInfoCol"> {oneOrgData?.email}</div>
              </div>
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Phone</div>
                <div className="partnerInfoCol">{oneOrgData?.phone}</div>
              </div>
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Address</div>
                <div className="partnerInfoCol">
                  {oneOrgData?.addressOutputs.map((address) => {
                    return address.street;
                  })}</div>
              </div>
                <div className="partnerInfoRow">
                <div className="partnerInfoCol">Postal Code</div>
                <div className="partnerInfoCol">
                  {oneOrgData?.addressOutputs.map((address) => {
                    return address.postalCode;
                  })}</div>
              </div>
            </div>
          </div>
        )}

        {microsite ? (
          <Preview micrositeId={microsite} RemoveMicrosite={RemoveMicrosite} />
        ) : (
          <></>
        )}
      </Modal>
    </>
  );
}

// }
